<template>
  <div class="home">
    <Header></Header>
    <Nav :title="title"></Nav>
    <div class="banner">
      <div class="left">
        <li
          v-for="(i, j) in navleft"
          :key="j"
          :class="nav_left == j ? 'isactive' : ''"
          @click="changeleft(j, i.volumeId)"
        >
          {{ i.volumeName }}
        </li>
      </div>
      <div class="right">
        <div class="top">
          <li
            v-for="(i, j) in navtop"
            :key="j"
            :class="nav_top == j ? 'active' : ''"
            @click="changetop(j)"
          >
            {{ i.name }}
          </li>
        </div>
        <div class="content">
          <li
            v-for="(i, j) in homelists"
            :key="j"
            @click="
              $router.push({
                path: '/detail',
                query: { articleId: i.articleId }
              })
            "
          >
            <p>{{ i.title }}</p>
            <span>阅读</span>
          </li>
        </div>
        <el-pagination
          style="text-align: center;margin-top: 50px;"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="45"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import Nav from "../components/nav.vue";
import API from "../api/api_user";
export default {
  name: "home",
  data() {
    return {
      title: "/information",
      nav_left: 0,
      nav_top: 0,
      navleft: [
        { isOriginal: "", volumeId: "", volumeName: "全部", volumeNum: "" }
      ],
      navtop: [{ name: "报纸查询" }],
      pageNum: 1,
      isSort: "",
      volumeId: "",
      homelists: "",
      currentPage: 1,
      total: 0
    };
  },
  components: {
    Header,
    Footer,
    Nav
  },

  watch: {
    $route(to, from) {
      // 路由发生变化页面刷新
      this.$router.go(0);
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.pageNum = val;
      this.homelist();
    },
    changeleft(j, volumeId) {
      this.nav_left = j;
      this.volumeId = volumeId;
      this.homelist();
    },
    changetop(j) {
      this.nav_top = j;
    },
    getvolumename() {
      API.volumename({ pageNum: "", pageSize: "" }).then(res => {
        res.data.rows.forEach(element => {
          var arr = {
            isOriginal: element.isOriginal,
            volumeName: element.volumeName,
            volumeId: element.volumeId,
            volumeNum: element.volumeNum
          };
          this.navleft.push(arr);
        });
      });
    },
    homelist() {
      API.homelist({
        pageNum: this.pageNum,
        pageSize: 45,
        volumeId: this.volumeId,
        isSort: this.isSort
      }).then(res => {
        this.homelists = res.data.rows;
        this.total = res.data.total;
      });
    }
  },
  computed: {},
  created() {
    this.homelist();
    this.getvolumename();
  },
  mounted() {}
};
</script>
<style>
/* 内容 */
.home .banner {
  width: 1200px;
  min-height: 400px;
  height: 800px;
  margin: 20px auto 0px;
  background-color: #fff;
  display: flex;
}
.home .banner .left {
  width: 20%;
  height: 800px;
  background-color: rgb(75, 72, 72);
  display: inline-block;
  overflow-y: scroll;
}
.home .banner .left li {
  list-style: none;
  vertical-align: top;
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  border-bottom: 1px dashed #fff;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
.home .banner .left .isactive {
  background-color: red;
}
.home .banner .right {
  width: 80%;
  height: 800px;
  display: inline-block;
  vertical-align: top;
  margin-left: 15px;
  border: 1px solid #ccc;
}
.home .banner .right .top {
  width: 100%;
  height: 40px;
  background-color: #f1f1f1;
  border-bottom: 1px solid #ccc;
}
.home .banner .right .top li {
  list-style: none;
  display: inline-block;
  width: 100px;
  text-align: center;
  line-height: 40px;
  border-right: 1px solid #ccc;
}
.home .banner .right .top .active {
  background-color: #fff;
  height: 41px;
}
.home .banner .right .content {
  width: 100%;
  height: auto;
}
.home .banner .right .content li {
  list-style: none;
  width: 20%;
  height: auto;
  display: inline-block;
  text-align: center;
  margin-top: 25px;
}
.home .banner .right .content li p {
  margin: 0px;
  margin-bottom: 5px;
}
.home .banner .right .content li span {
  background-color: red;
  color: #fff;
  font-size: 14px;
  padding: 3px 10px;
}
</style>
